<template>
  <m-dropdown
    v-model:value="show"
    :class="['color-picker']"
    :title="$t('colorPicker.title')"
    :disabled="readOnly || disabled"
    close-on-click
    :block="fullWidth"
  >
    <m-focusable
      class="_trigger"
      type="clickable"
      :hide-border="hideBorder"
      :hide-hover="hideHover"
      :disabled="disabled"
      :read-only="readOnly"
      :full-width="fullWidth"
      light
    >
      <div class="_value">
        <color-item
          :color="value"
          :shade="shade"
        />
        <span
          v-if="fullWidth"
          class="_text"
        >{{ title }}</span>
      </div>
      <template
        v-if="!hideArrow && fullWidth && !disabled && !readOnly"
        #suffix
      >
        <m-icon
          class="_icon"
          size="11"
          :color="$colors.grey.lighten1"
          type="right"
        />
      </template>
    </m-focusable>
    <template #overlay>
      <m-card
        list
        no-padding
        :style="{ minWidth: '20rem' }"
      >
        <color-list
          :items="items"
          :value="value"
          :shade="shade"
          @select="select"
        />
      </m-card>
    </template>
  </m-dropdown>
</template>

<script>
import ColorItem from '@/components/ColorItem.vue';
import ColorList from '@/components/ColorList.vue';
import { camelCase } from 'lodash-es';
import { optionColor } from 'shared/constants.json';

export default {
  name: 'ColorPicker',
  props: {
    value: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    hideBorder: {
      type: Boolean,
      default: false,
    },
    hideHover: {
      type: Boolean,
      default: false,
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    shade: {
      type: String,
      default: '',
    },
  },
  components: { ColorList, ColorItem },
  emits: ['input', 'update:value'],
  data() {
    return { show: false };
  },
  computed: {
    clickable() {
      return !this.readOnly && !this.disabled;
    },
    title() {
      return this.$t(`colorPicker.${camelCase(this.value)}`);
    },
    items() {
      return optionColor.all.map((c) => ({
        text: this.$t(`colorPicker.${camelCase(c)}`),
        value: c,
      }));
    },
  },
  methods: {
    open() {
      this.show = true;
    },
    select(item) {
      if (!this.clickable) {
        return;
      }
      this.$emit('input', item.value);
      this.$emit('update:value', item.value);
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .color-picker {
    ._value {
      display: flex;
      align-items: center;
      gap: .6rem;
    }

    ._text {
      font-size: 1.4rem;
    }
  }
</style>
